export default __webpack_public_path__ + "/assets/hero-ab-suite.jpg";